export default __webpack_public_path__ + "static/international-yards-mobile-0def04d722eed9001b626e53c485a0ea.svg";